export default class accountWishlistCtrl {
    constructor($scope, $http, $rootScope, $compile) {
        'ngInject';

        var accountScope = angular.element('#account-wrap').scope();
        
        $scope.inWishlist = function(variant_id){
            return ($rootScope.wishlist.indexOf(variant_id)>-1)
        }

        //Add To Wishlist
        $scope.addToWishlist = function (variant_id, product_id) {
            $(".add-to-wishlist").removeClass("active");
            $rootScope.showOverlay('product-content-'+variant_id);
            $http({
                method: "GET",
                url: "/en/cart/addtowishlist?variant_id=" + variant_id + "&product_id=" + product_id,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
            }).then(function success(response) {
                var data = response.data;
                console.log('Add To Wishlist Success: ', data);
                accountScope.getUserWishlist();
                $rootScope.hideOverlay('product-content-'+variant_id);
                $rootScope.wishlist.push(variant_id);
            }, function error(response) {
                var data = response.data;
                console.log('Add To Wishlist Error: ', data);
                accountScope.getUserWishlist();
                $rootScope.hideOverlay('product-content-'+variant_id);
            })
            // $rootScope.getUserWishlist();
        };

        $scope.addToCartFromWishlist = function (product_id, variant_id) {
            $http({
                method: "POST",
                url: "/en/cart/addtocartfromwishlist",
                data: $rootScope.params({
                    p_id: product_id,
                    v_id: variant_id
                }),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
            }).then(function success(response) {
                var data = response.data;
                accountScope.getUserWishlist();
                $rootScope.session.order.cart = data.cart;
            }, function error(response) {
                var data = response.data;
                $rootScope.session.order.cart = data.cart;
                console.log('Error: ', data);
            });
        };

        $scope.removeFromWishlist = function (id) {
            $http({
                method: "GET",
                url: "/cart/removefromwishlist/" + id
            }).then(function success(response) {
                var data = response.data;
                if (data.success == 1) {
                    accountScope.getUserWishlist();
                }
                accountScope.getUserWishlist();
            }, function error(response) {
                var data = response.data;
                console.log('Error: ', data);

            });
        };

        $scope.emptyWishlist = function () {
            $http({
                method: "GET",
                url: "/cart/emptywishlist"
            }).then(function success(response) {
                var data = response.data;
                accountScope.getUserWishlist();
                $rootScope.wishlist = [];
            }, function error(response) {
                var data = response.data;
                console.log('Error: ', data);

            });
        };


    }
}